"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagKoIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagKoIcon = (0, _mobxReact.observer)(_class = (_FlagKoIcon = /*#__PURE__*/function (_React$Component) {
  function FlagKoIcon() {
    _classCallCheck(this, FlagKoIcon);
    return _callSuper(this, FlagKoIcon, arguments);
  }
  _inherits(FlagKoIcon, _React$Component);
  return _createClass(FlagKoIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 287 287",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#EAEAEA",
        d: "M0 0h287v287H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#000",
        d: "M96.927 81.106l-27.735 41.605-27.736-18.49 27.735-41.605z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#EAEAEA",
        d: "M81.904 66.082l-32.357 48.539-3.468-2.312 32.357-48.538zM92.379 72.998l-32.358 48.534-3.467-2.311 32.358-48.534z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#000",
        d: "M249.465 182.808l-27.735 41.605-27.736-18.49 27.735-41.605z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#EAEAEA",
        d: "M234.526 167.755l-32.358 48.534-3.467-2.312 32.357-48.533zM244.842 174.717l-32.357 48.538-3.468-2.311 32.357-48.539z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#EAEAEA",
        d: "M240.221 204.183l-2.311 3.467-34.672-23.113 2.312-3.467z"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        fill: "#C60C30",
        cx: "145.5",
        cy: "143.5",
        r: "50"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M103.898 115.765c-7.659 11.488-4.555 27.01 6.934 34.669 11.488 7.659 27.01 4.554 34.669-6.934 7.659-11.488 23.18-14.592 34.669-6.934 11.488 7.659 14.592 23.18 6.934 34.669-15.317 22.977-46.361 29.185-69.337 13.867-22.978-15.317-29.187-46.361-13.869-69.337",
        fill: "#003478"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#000",
        d: "M69.188 164.311l27.735 41.605-27.736 18.49L41.452 182.8z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#EAEAEA",
        d: "M49.543 172.401L81.9 220.94l-3.468 2.311-32.357-48.538zM60.025 165.446l32.358 48.534-3.467 2.311-32.358-48.534z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#000",
        d: "M221.735 62.623l27.735 41.605-27.736 18.49-27.735-41.605z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#EAEAEA",
        d: "M202.162 70.678l32.358 48.534-3.467 2.312-32.358-48.535zM212.49 63.779l32.357 48.538-3.467 2.312-32.357-48.539z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#EAEAEA",
        d: "M237.948 79.4l2.311 3.468-34.67 23.112-2.312-3.467z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#000",
        d: "M222.94 86.842l4.623 6.933-6.934 4.623-4.623-6.933z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#EAEAEA",
        d: "M74.992 188.026l2.312 3.467-13.87 9.246-2.31-3.468z"
      }))));
    }
  }]);
}(_react["default"].Component), _FlagKoIcon.defaultProps = {
  width: '20px'
}, _FlagKoIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagKoIcon);